import { faPen, faTelescope } from '@fortawesome/pro-solid-svg-icons'
import { Box, Button } from '@material-ui/core'
import { BasicEmptyState, CoreEmptyState } from '@scoir/empty-state'

import NewContentMenuButton from '../NewContentMenuButton'

type ContentTableEmptyStateProps = {
  canManageContent?: boolean
  isFiltered?: boolean
  clearFilters?: () => void
}

const ContentTableEmptyState = ({
  canManageContent = true,
  isFiltered = false,
  clearFilters,
}: ContentTableEmptyStateProps) => {
  if (!canManageContent) {
    return (
      <BasicEmptyState
        title="You don’t have permission to add content"
        subTitle="Contact your school’s administrator to grant you the appropriate access."
        icon={faPen}
      />
    )
  }
  return isFiltered ? (
    <CoreEmptyState
      title="Nothing here yet"
      subTitle="No content matches your current filters. Try adjusting your filters or create new content."
      icon={faTelescope}
    >
      <Box
        display="flex"
        gridGap={16}
      >
        <Button
          variant="outlined"
          onClick={clearFilters}
          color="primary"
        >
          Clear Filters
        </Button>
        <NewContentMenuButton />
      </Box>
    </CoreEmptyState>
  ) : (
    <CoreEmptyState
      title="Start standing out from the crowd"
      subTitle="Add a post, event, or program to start sharing content. Tag items to match student interests so the right students and supporters see them."
      icon={faPen}
    >
      <NewContentMenuButton />
    </CoreEmptyState>
  )
}

export default ContentTableEmptyState
